//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
export default {
	name: 'scenicSpotList',
	props: {
		isMulti: {
			type: Boolean,
			default: false
		},
		single: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			spotList: [],
			spotData: [],
			loading:false
		}
	},
	components: {
		uniLoadMore
	},
	mounted () {
		this.queryData()
	},
	computed: {
		list () {
			return this.spotList.map((t) => {
				return {
					name: t.name,
					isMore: t.isMore,
					length: t.children.length,
					children: t.isMore ? t.children : t.children.slice(0, 6)
				}
			})
		},
		isSHowList () {
			let array = []
			this.spotList.forEach(t => {
				if (t.children) {
					t.children.forEach(tt => {
						if (tt.isShow) {
							array.push(tt)
						}
					})
				}
			})
			return array
		}
	},
	methods: {
		showMore(t,i){
			this.spotList[i].isMore=!t.isMore
		},
		queryData(){
			let _this = this
			this.loading = true
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/scenicspot/querylistGroupbyRegionCode',
				data: {}
			}).then(res=>{
				_this.spotList = res.data.map((t) => {
					let children = []
					children = t.value.map(tt => {
						return {
							isShow: false,
							...tt
						}
					})
					return {
						name: t.name,
						isMore: false,
						children: children
					}
				})
				_this.loading = false
			})
		},
		handleItem (item) {
			if (!this.isMulti) {
				this.$emit('handleItem', item)
			} else {
				item.isShow = !item.isShow
				if (this.single) {
					this.spotList.forEach(t => {
						if (t.children) {
							t.children.forEach(tt => {
								if (tt.name !== item.name) {
									tt.isShow = false
								}
							})
						}
					})
				}
			this.$emit('handleItem', this.isSHowList)
			}
		},
		cancel (item) {
			this.spotList.forEach(t => {
				if (t.children) {
					t.children.forEach(tt => {
						if (tt.name === item.name) {
							tt.isShow = false
						}
					})
				}
			})
			this.$emit('handleItem', this.isSHowList)
		}
	}
}
